module.exports = __webpack_public_path__ + "img/paymentMethods.62a39957.svg";